import { render, staticRenderFns } from "./AnswerIcon.vue?vue&type=template&id=2463bc27&"
import script from "./AnswerIcon.vue?vue&type=script&lang=js&"
export * from "./AnswerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports